function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#map-icon_svg__clip0)",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("path", {
  d: "M14.063 0a3.942 3.942 0 00-3.938 3.938c0 2.02 3.159 5.599 3.519 6a.565.565 0 00.837 0c.36-.401 3.519-3.98 3.519-6A3.942 3.942 0 0014.062 0zm0 5.625a1.688 1.688 0 110-3.376 1.688 1.688 0 010 3.376zM.353 6.608A.564.564 0 000 7.131v10.306a.564.564 0 00.772.522l4.853-1.941V4.5L.353 6.608z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.318 10.69c-.32.356-.777.56-1.255.56-.479 0-.937-.204-1.256-.56a23.95 23.95 0 01-.432-.493V18l5.272-2.108A.561.561 0 0018 15.37V7.1c-.921 1.56-2.153 3-2.682 3.59zM9.354 5.542L6.75 4.5v11.518l4.5 1.8V8.784c-.719-.969-1.47-2.135-1.896-3.242z"
}));

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "map-icon_svg__clip0"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h18v18H0z"
})));

function SvgMapIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    fill: "none"
  }, props), _ref, _ref2);
}

export default SvgMapIcon;